module.exports = __webpack_public_path__ + "static/media/confetti.8978515d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/confetti.svg
// module id = 807
// module chunks = 50